<template>
    <generic-page>
        <back-to-settings />

        <div class="d-flex align-items-center justify-content-between mt-3">
            <h5 class="mb-0">Video - Upvoted</h5>
        </div>

        <div class="py-2">
            <div v-if="loading">
                <generic-loading />
            </div>
            <div v-else-if="creatorVideos && creatorVideos.length">
                <div class="video-grid">
                    <div
                        v-for="{ creatorVideo } in creatorVideos"
                        :key="creatorVideo.id"
                        @click="
                            $router.push({
                                name: 'creatorVideoIndex',
                                params: { slug: creatorVideo.slug },
                            })
                        "
                    >
                        <creator-video-avatar :creatorVideo="creatorVideo" />
                    </div>
                </div>
            </div>
            <div v-else class="text-center text-secondary py-4">
                No upvoted videos yet
            </div>
        </div>

        <generic-pagination
            @next="next"
            @previous="previous"
            :hasMorePages="hasMorePages"
            :page="page"
        />
    </generic-page>
</template>

<style scoped>
.video-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
}
</style>

<script>
import BackToSettings from "@/components/setting/utility/BackToSettings";
import GenericPagination from "@/components/utility/GenericPagination";
import CreatorVideoAvatar from "@/components/creatorVideo/CreatorVideoAvatar";

export default {
    data() {
        return {
            page: 1,
            hasMorePages: false,
            creatorVideos: null,
            loading: false,
        };
    },
    created() {
        this.refresh();
    },
    methods: {
        next() {
            this.page++;
            this.refresh();
        },
        previous() {
            this.page--;
            this.refresh();
        },
        refresh() {
            this.loading = true;

            this.api
                .post("/creatorVideo/customerUpvoted", {
                    page: this.page,
                })
                .then((response) => {
                    this.creatorVideos = response?.data?.creatorVideos;
                    this.hasMorePages = response?.data?.hasMorePages;
                })
                .catch(() => {})
                .then(() => {
                    this.loading = false;
                });
        },
    },
    components: {
        BackToSettings,
        GenericPagination,
        CreatorVideoAvatar,
    },
};
</script>
